// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".storeEdit[data-v-4bb308da] {\n  padding: 0 35px;\n}\n.pictrue[data-v-4bb308da] {\n  width: 36px !important;\n  height: 36px !important;\n}", ""]);
// Exports
module.exports = exports;
